/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { array as codecArray, number as codecNumber, oneOf as codecOneOf, string as codecString, } from 'purify-ts/Codec';
import { parsers } from '@codegrade/utils';
import { AutoTestStepValidationException } from './AutoTestStepValidationException';
const InvalidIOCasesExceptionParser = 
/* #__PURE__ */ /* #__PURE__ */ codec.intersect(
/* #__PURE__ */ parsers.object([
    [
        'invalidCases',
        /* #__PURE__ */ codecArray(
        /* #__PURE__ */ codecArray(
        /* #__PURE__ */ codecOneOf([codecNumber, codecString]))),
        'invalid_cases',
    ],
]), AutoTestStepValidationException);
export class InvalidIOCasesException extends AutoTestStepValidationException {
    static decode(input) {
        return InvalidIOCasesExceptionParser.decode(input).map(res => new InvalidIOCasesException(res));
    }
    static unsafeDecode(input) {
        return InvalidIOCasesException.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return InvalidIOCasesExceptionParser.encode(data);
    }
    static schema() {
        return InvalidIOCasesExceptionParser.schema();
    }
}
